import { eNoteOwnerType, SearchContactBy } from "./enum.model";
import { SimpleResponse } from "./genericResponse.model";
import { SearchQueryResponse } from "./search.model";

export interface ContactExportRequest {

  requestTime: string;
  typeDisplay: number;
  statusDisplay: number;
  downloadNavURL: string;
  fileName: string;
}
export interface ContactExportRequestResponse extends SimpleResponse {

  contactExportRequests: ContactExportRequest[];
}

export interface ExportRequestResponse extends SimpleResponse {
  exportRequests: ExportRequest[];
}

export interface ExportRequestLoadResponse extends SimpleResponse {
  exportRequests: ExportRequest;
}

export interface ExportRequest {
  exportRequestID: number;
  cLPCompanyID: number;
  cLPUserID: number;
  customSearchID: number;
  fileName: string;
  objectType: number;
  whereClause: string;
  orderBy: string;
  document: string;
  documentType: number;
  documentLength: number;
  status: number;
  dtModified: string;
  dtCreated: string;
  includeMetrics: boolean;
  havingScore: string;
}

export interface ExportRequestSaveObj {
  clpCompanyId: number;
  clpUserId: number;
  selectedUserId: number;
  strUsers: string[];
  selectedTagIds: number[];
  tagSearchType: number;
  clickId: number;
  leadId: number;
  leadStatus: number;
  leadStatusCode: number;
  class6Code: number;
  class7Code: number;
  class8Code: number;
  officeCode: number;
  searchContactBy: SearchContactBy;
  ownerType: eNoteOwnerType;
  isIncludeMetrics: boolean;
  isAllActive: boolean;
  startDate: string;
  endDate: string;
  startDate2: string;
  endDate2: string;
  eDim1: string;
  dim1Value: string;
  eDim2: string;
  dim2Value: string;
  dateFilter: string;
  campaignId: number;
  campaignEventId: number;
}

export interface CreateExportRequestObj extends SimpleResponse {
  exportRequestObj: ExportRequest;
  searchQueryObj: SearchQueryResponse;
}
